<mat-card>
  <mat-card-title class="pl-4 md:pl-7">Favorites</mat-card-title>

  <mat-card-content class="px-4 md:px-8">
    @let favoritesLoaded = favoritesSelectors.finishedLoading | select:false;
    @let holdsLoaded = holdSelectors.finishedLoading | select:false;
    <px-cover-image-grid [catalogRecords]="favoritesSelectors.favorites | select:[]" mxHiddenUntilLoaded [reveal]="favoritesLoaded && holdsLoaded">
      <ng-template #catalogRecordInfo let-favorite="catalogRecord">
        <div class="flex flex-row gap-y-4 content-center justify-center">
          <mx-icon-button icon="favorite" color="error" (click)="removeFromFavorites(favorite)"/>
          <px-hold-icon-button [catalogRecordId]="favorite?.id"/>
        </div>

        <p mxTruncate [mxTruncateMaxLines]="2" class="text-label-large text-center">
          {{ statelessSelectors.titleFor(favorite) | select }}
        </p>
      </ng-template>

      <ng-template #noCatalogRecords>
        @if (favoritesLoaded) {
          <p class="text-body-large w-full text-center py-10">You don't have any favorites yet!</p>
        }
      </ng-template>
    </px-cover-image-grid>

    @if (favoritesSelectors.hasFavorites | select) {
      <mx-pagination itemsPerPageLabel="Items per page:" [class.loaded]="favoritesLoaded"/>
    }
  </mat-card-content>
</mat-card>
